import { useTranslation } from "react-i18next";
import Modal from "@/components/Modals/Modal";
import ImgTag from "@/components/Helpers/ImgTag";
import { EMKAN_LOGO_SRC } from "@/constants/payments";

const TERMS_KEYS = [
  "emkanTermsInstallments",
  "emkanTermsMinInvoice",
  "emkanTermsMaxInvoice",
];

const EmkanCloseIcon = (props) => (
  <svg
    viewBox="0 0 19.8367 19.8367"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M14.8793 4.95923L4.96094 14.8776M4.96094 4.95923L14.8793 14.8776"
      stroke="currentColor"
      strokeWidth="1.65306"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const EmkanModal = ({ onClose }) => {
  const { t } = useTranslation("common");

  const header = (
    <div className="relative flex items-center justify-center px-3 py-[9px] md:px-5 md:py-[15px] shrink-0 bg-emkan">
      <ImgTag
        src={EMKAN_LOGO_SRC}
        width={117}
        height={46}
        // the dialog mounts on open, so a lazy image would pop in after it
        loading="eager"
        className="h-7 w-[71px] md:h-[46px] md:w-[117px]"
        alt={t("emkanName")}
      />
      <button
        type="button"
        aria-label={t("emkanTermsClose")}
        onClick={onClose}
        className="absolute p-1 -m-1 text-white top-[9px] end-3 md:top-[15px] md:end-5"
      >
        <EmkanCloseIcon className="size-3 md:size-5" />
      </button>
    </div>
  );

  return (
    <Modal
      isOpen
      dismissible
      onClose={onClose}
      header={header}
      panelClassName="max-w-[311px] md:max-w-[512px] rounded-lg md:rounded-[13px]"
    >
      <div className="pt-4 md:pt-[27px] text-[10px] md:text-base font-medium text-emkan-muted ltr:font-poppins rtl:font-noto">
        <h2 className="font-bold leading-[17px] md:leading-[27.5px] text-emkan">
          {t("emkanTermsTitle")}
        </h2>
        <p className="mt-1 md:mt-1.5 leading-[17px] md:leading-[27.5px]">
          {t("emkanTermsIntro")}
        </p>
        <ul className="mt-2 md:mt-4 list-disc leading-[21.5px] md:leading-[35.5px]">
          {TERMS_KEYS.map((key) => (
            <li key={key} className="ms-[15px] md:ms-6">
              {t(key)}
            </li>
          ))}
        </ul>
      </div>
    </Modal>
  );
};

export default EmkanModal;
